import { useForm } from "react-hook-form";
import { useAccountRecoveryMutation } from "app/services/api/authorisationApi";
import { AccountRecoveryRequest } from "app/services/api/types/authorisation/requests/AccountRecoveryRequest";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { ToastModel } from "ui/types/ToastModel";

export const useAccountRecovery = (onRecoverySent?: () => void) => {
  const { showNewToast } = useDisplayToast();
  const [triggerRecovery, { isLoading }] = useAccountRecoveryMutation();

  const { control, handleSubmit } = useForm<AccountRecoveryRequest>({
    defaultValues: {
      email: "",
    },
  });

  const handleToast = (toast: ToastModel) => {
    showNewToast(toast);
  };

  const submitForm = handleSubmit(async (data: AccountRecoveryRequest) => {
    try {
      await triggerRecovery(data).unwrap();
      onRecoverySent?.();

      handleToast({
        id: "recovery-sent",
        title: "Password recovery email sent!",
        message:
          "An email was sent that will ask you to click on a link to verify that you own this account. If you don't get the email, please contact support@icare.com.mt",
        type: "success",
      });
    } catch (e) {
      handleToast({
        id: "recovery-error",
        title: "Something went wrong",
        message:
          "An error occurred. Please check your connection and try again.",
        type: "error",
      });
      console.error("Error:", e);
    }
  });

  return { control, submitForm, isLoading };
};
